// extracted by mini-css-extract-plugin
module.exports = {"navigationButton":"style_navigationButton__2Lm0l","wrapperChip":"style_wrapperChip__1rmn_","bold":"style_bold__i0EFs"};